export enum MenuItems {
  SiteSelector = 'SiteSelector',
  Search = 'Search',
}
